export default __webpack_public_path__ + "static/media/fs-logo.090d72eb.svg";